import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { STORE } from './redux/Store';
import { Provider } from 'react-redux';
import { enableMapSet } from 'immer';
import * as Sentry from '@sentry/react';
import { AppWithTheme } from './AppWithTheme';
import { Settings } from 'luxon';

Settings.defaultLocale = 'fr';

Sentry.init({
  dsn: 'https://3783f14011194009af1d85b29ada29e7@o69815.ingest.sentry.io/5222208',
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.2,
});

enableMapSet();

createRoot(document.getElementById('root')!).render(
  <Provider store={STORE}>
    <AppWithTheme />
  </Provider>,
);
